/* eslint-disable no-empty-pattern */
import { headers } from '@/_services/headers'
const state = {
    allHotels: [],
    listOfHotels: [],
    getHotelById: [],
};
const mutations = {
    // set all airports
    SET_ALL_HOTELS(state, payload) {
        state.allHotels = payload;
    },
    // set list of hotels
    SET_LIST_OF_HOTELS(state, payload) {
        state.listOfHotels = payload;
    },
    // set hotel by id
    SET_HOTEL_BY_ID(state, payload) {
        state.getHotelById = payload;
    }
};
const actions = {
    // get all HOTELS
    async getAllHotels({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Hotel/GetAll?platform=1`, { headers });
            if (response.status === 200) {
                commit('SET_ALL_HOTELS', response.data.allHotels);
                return response;
            }
        }
    },
    // get list of flights
    async searchHotel({ commit }, payload) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Hotel/Search`, payload, { headers });
            if (response.status === 200) {
                commit('SET_LIST_OF_HOTELS', response.data);
                return response;
            }
        }
    },
    // get hotel by id
    async fetchlistOfHotelRooms({ commit }, { data }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Hotel/${data.hotelId}?searchKey=${data.searchKey}&appPlatform=1`, { data }, { headers });
            if (response.status === 200) {
                commit('SET_HOTEL_BY_ID', response.data);
                return response;
            }
        }
    }
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};